import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    minWidth: '600px',
    borderRadius: '16px',
    backgroundColor: '#313234',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minHeight: 'auto',
  padding: '40px',
}));

export const CloseButton = styled(ButtonBase)(() => ({
  color: '#707070',
  float: 'right',
  '&:hover': {
    color: '#EDEFF2',
  },
  '&:active': {
    color: '#E89710',
  },
  '& span': { fontSize: '28px', fontWeight: '600' },
}));

export const StyledTitle = styled(DialogTitle)(() => ({
  color: '#EDEFF2',
  fontSize: '21px',
  fontWeight: '600',
  padding: '16px 0',
  textTransform: 'capitalize',
  marginBottom: '20px',
}));

export const PictureGrid = styled(Grid)(() => ({
  margin: '20px',
}));

type UploadButtonProps = {
  component: string;
};

export const UploadButton = styled(ButtonBase)<UploadButtonProps>(
  ({ component }) => ({
    color: '#EDEFF2',
    textTransform: 'lowercase',
    fontSize: '18px',
    margin: '20px 0',
    borderRadius: '8px',
    padding: '0 10px',
    component,
    '&:hover': {
      color: '#E89710',
      textDecoration: 'underline',
    },
  })
);

export const StyledTextField = styled(TextField)(() => ({
  marginBottom: '40px',
  width: '100%',
  '& .MuiInputBase-input': {
    color: '#FFF',
    fontSize: '18px',
  },
  '& .MuiInputBase-root.MuiInput-root:before': {
    borderBottom: '1px solid #8B8C8E',
  },
  '& .MuiInputBase-root.MuiInput-root:after': {
    borderBottom: '1px solid #8B8C8E',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:before': {
    borderBottom: '1px solid #EDEFF2',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:after': {
    borderBottom: '1px solid #EDEFF2',
  },
}));

export const ButtonGrid = styled(Grid)(() => ({
  width: '100%',
  justifyContent: 'start',
  gap: 128,
  padding: '20px',
}));

export const OutlinedButton = styled(Button)(() => ({
  border: '1.5px solid',
  borderColor: '#E89710',
  textTransform: 'lowercase',
  maxWidth: '200px',
}));

export const FilledButton = styled(Button)(() => ({
  border: '1.5px solid',
  borderColor: '#E89710',
  backgroundColor: '#E89710',
  textTransform: 'lowercase',
  color: '#EDEFF2',
  maxWidth: '200px',
}));

export const PatternFormatStyles = {
  marginBottom: '40px',
  width: '100%',
  '& .MuiInputBase-input': {
    color: '#FFF',
    fontSize: '18px',
  },
  '& .MuiInputBase-root.MuiInput-root:before': {
    borderBottom: '1px solid #8B8C8E',
  },
  '& .MuiInputBase-root.MuiInput-root:after': {
    borderBottom: '1px solid #8B8C8E',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:before': {
    borderBottom: '1px solid #EDEFF2',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:after': {
    borderBottom: '1px solid #EDEFF2',
  },
};
